const LOCATIONS = [
    'Abu Dhabi',
    'Ajman',
    'Al Ain',
    'Al Dhafra',
    'Dubai',
    'Fujairah',
    'Ras Al Khaimah',
    'Sharjah',
    'Um Al Quwain'
  ];
  
  module.exports = LOCATIONS;